import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { assertOnlineOrThrow } from '../lib/offlineGuard';

/** @param {object} row get_placement_ads RPC row */
function mapPlacementAdRow(row) {
  if (!row?.campaign_id) return null;
  const title = String(row.title || '').trim();
  if (!title) return null;

  return {
    id: String(row.campaign_id),
    businessId: row.business_id ? String(row.business_id) : null,
    image: String(row.image || '').trim(),
    title,
    description: String(row.description || '').trim(),
    location: String(row.region || '').trim(),
    link: row.link_url?.startsWith('/') ? row.link_url : row.link_url || `/business/${row.business_id}`,
  };
}

/**
 * 화면 노출 CPM 광고 — SECURITY DEFINER RPC (get_placement_ads), ad_campaigns +
 * ad_placements(inventory_type='placement_feed_cpm') 기반. 채팅/커뮤니티/모임/프로필/
 * 업체대시보드 등 여러 화면이 slot_key로 이 하나의 RPC를 공유해서 씀.
 * @param {string} slotKey e.g. 'chat_feed_cpm' | 'community_feed_cpm' | 'group_feed_cpm' | 'profile_feed_cpm' | 'business_dashboard_cpm'
 * @param {number} [limit]
 * @param {string|null} [category] businesses.category 값(예: 'food_cafe_mart'). local_listing_feed_cpm처럼
 *   여러 업종 화면이 슬롯 하나를 공유할 때, 화면의 업종과 일치하는 광고만 우선 노출시키기 위함.
 *   광고주가 자동타겟팅 안 된 캠페인(target_category null)은 어떤 category를 넘겨도 항상 노출됨.
 */
export async function fetchPlacementAds(slotKey, limit = 4, category = null) {
  if (!isSupabaseConfigured || !slotKey) return [];
  const sb = getSupabase();
  if (!sb) return [];

  try {
    assertOnlineOrThrow();
  } catch {
    return [];
  }

  const { data, error } = await sb.rpc('get_placement_ads', {
    p_slot_key: slotKey,
    p_limit: Math.max(1, limit),
    p_category: category || null,
  });

  if (error) {
    console.warn('[fetchPlacementAds]', slotKey, error.message || error);
    return [];
  }

  return (data || []).map(mapPlacementAdRow).filter(Boolean);
}
